import { Theme } from '@material-ui/core';
import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default ({ palette: plt }: Theme) =>
  createStyles({
    iconYellow: {
      color: palette.navCompanyContextActions,
      fontSize: 22,
    },
    iconGreen: {
      color: palette.navAdmin,
      fontSize: 22,
    },
    iconGray: {
      color: palette.navSuperAdminActions,
      fontSize: 22,
    },
    iconBlue: {
      color: palette.navOperator,
      fontSize: 22,
    },

    content: {
      marginTop: 32,
    },

    cardsContent: {
      padding: '8px 24px 16px',

      '& .MuiOutlinedInput-root': {
        height: 45,
      },
    },

    buttons: {
      margin: '40px auto',

      '& .MuiButtonBase-root': {
        margin: '0 8px',
      },
    },

    autocomplete: {
      width: '100%',
      flex: 1,
      '& .MuiInputBase-input.Mui-disabled': {
        backgroundColor: palette.backgroundWhite,
      },
      '& .MuiOutlinedInput-inputAdornedStart': {
        flex: 1,
        minWidth: 100,
        padding: 0,
        marginLeft: 4,
        height: '19px !important',
        margin: '10px 0px',
      },

      '& .MuiChip-outlined': {
        marginTop: 10,
        marginRight: 3,
      },
      '& .MuiInputBase-root': {
        display: 'inline',
        height: 'auto',
      },
      '& .MuiOutlinedInput-multiline': { padding: '0px 0px 0px 10px' },
    },
    autocompleteError: {
      '& .MuiFormLabel-root, .MuiFormLabel-root.MuiFocused': {
        color: plt.error.light,
      },
      '& .MuiOutlinedInput-root, .MuiOutlinedInput-root:hover, .MuiOutlinedInput-root.Mui-focused': {
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: plt.error.light,
        },
      },
    },

    errorMessage: {
      padding: 0,
      fontSize: 12,
    },

    chipError: {
      color: plt.error.light,
      borderColor: plt.error.light,
    },
    chipIcon: {
      color: plt.error.light,
      fontSize: 14,
      paddingLeft: 4,
    },
    chipDeleteIcon: {
      color: plt.error.light,

      '&:hover': {
        color: plt.error.dark,
      },
    },
  });
